import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import ProfileTab from "./profile";
import Expertise from "./expertise";
import LocationTab from "./location";
import PF from "./pf";
import ChangePasswordTab from "./change-password";

import AlertResponse from "../../shared/general/AlertResponse";
import EmployeeWelfareFund from "./employee-welfare-fund";

const StyledTabs = styled(Tabs)({
  "& .Mui-selected": {
    color: "#212b36 !important",
  },
  "& .fal": {
    marginRight: 8,
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TAB_HASH = {
  1: "profile",
  2: "address",
  3: "education",
  4: "employee-welfare-fund",
  5: "password",
};

const getValueFromHash = (hash) => {
  const key = String(hash || "").replace("#", "");
  const found = Object.keys(TAB_HASH).find((tabValue) => TAB_HASH[tabValue] === key);
  return found ? Number(found) : 1;
};

const RightPanel = () => {
  let location = useLocation();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { result: userProfile } = useSelector(state => state.userProfile);
  const tabItem = [
    {
      label: t("PersonalInfo"),
      icon: <i className="fal fa-address-card"></i>,
      component: <ProfileTab />,
      value: 1
    },
    {
      label: t("Address"),
      icon: <i className="fal fa-map-marked-alt"></i>,
      component: (
        <LocationTab setOpenAlert={setOpenAlert} setAlertType={setAlertType} />
      ),
      value: 2
    },
    {
      label: t("Education"),
      icon: <i className="fal fa-user-graduate"></i>,
      component: <Expertise />,
      value: 3
    },
    // {
    //   label: t("ProvidentFund"),
    //   icon: <i className="fa-regular fa-sack-dollar"></i>,
    // },
    {
      label: t("employeeWelfareFund"),
      icon: <i className="fa-regular fa-circle-dollar-to-slot" />,
      component: <EmployeeWelfareFund />,
      value: 4
    },
    {
      label: t("ChangePass"),
      icon: <i className="fa-regular fa-unlock-keyhole"></i>,
      component: <ChangePasswordTab />,
      value: 5
    },
  ];
  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState(false);

  const visibleTabItem = tabItem.filter((v) => {
    if (userProfile && userProfile.isEmployeeWelfareFund !== 1) {
      return v.value !== 4;
    } else {
      return true;
    }
  });

  const hashValue = getValueFromHash(location.hash);
  const value = visibleTabItem.some((v) => v.value === hashValue)
    ? hashValue
    : 1;

  const handleChange = (event, newValue) => {
    history.push({ hash: TAB_HASH[newValue] || TAB_HASH[1] });
  };

  const handleChangeAlertType = (newValue) => {
    setAlertType(newValue);
  };

  const handleOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  return (
    <div style={{ width: "100%", marginTop: 16 }}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        scrollButtons="auto"
        variant="scrollable"
        aria-label="scrollable auto tabs example"
      >
        {visibleTabItem.map((value, index) => (
          <Tab
            key={index}
            label={
              <Typography>
                {value.icon} {value.label}
              </Typography>
            }
            {...a11yProps(value.value)}
            value={value.value}
          />
        ))}
      </StyledTabs>
      <TabPanel value={value} index={1}>
        <ProfileTab
          handleChangeAlertType={handleChangeAlertType}
          handleOpenAlert={handleOpenAlert}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <LocationTab
          handleChangeAlertType={handleChangeAlertType}
          handleOpenAlert={handleOpenAlert}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Expertise />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <EmployeeWelfareFund />
      </TabPanel>
      <TabPanel value={value} index={5}>
        {/* <PF />
      </TabPanel>
      <TabPanel value={value} index={4}> */}
        <ChangePasswordTab />
      </TabPanel>

      <AlertResponse
        open={openAlert}
        handleClose={handleCloseAlert}
        alertType={alertType}
      />
    </div>
  );
};

export default RightPanel;
